import moengage from "@moengage/web-sdk";
import { Card, Divider, Dropdown, Input, Modal, Radio, Tag } from 'antd';
import { CurrencyFormat } from "app/Components/CurrencyFormat";
import ActivityLoaderMintbox from 'assets/styles/components/ActivityLoaderMintbox';
import { isSubsequence } from "Libs/utils";
import React, { useState } from 'react';
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaChartPie, FaUserFriends } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";
import { toast } from 'react-toastify';
import AdminServicesPYV2 from "services/api/AdminServicesPYV2";
import { CardHeader } from "../../Components/Atoms/CardHeader";
import { useAuth } from '../../context/AuthContext';
import AdminServices from '../../services/api/AdminServices';
import MyTable from '../Components/TableWithScroll';
import styles from '../dashboard/dashboard.module.css';
import { formatDate, formatDateyyyymmdd } from '../shared/components/DateFormatter';
import { ClientOneTimePays } from './ClientOneTimePays';
import { ClientSubscriptions } from './ClientSubscriptions';
export default function ManageClientsWithWealth(props) {

  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [reportloading, setreportLoading] = React.useState(true)
  const [displayData, setDisplayData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [selectedClient, setSelectedClient] = React.useState('');
  const [showClientSubs, setShowClientSubs] = React.useState(false);
  const [showClientOneTimePay, setShowClientOneTimePay] = React.useState(false);
  const [appliedFilters, setAppliedFilters] = React.useState({});
  const [pt_data, set_pt_data] = React.useState([]);
  const [totalD, setTotalD] = React.useState({});
  const [updateAccessModalParams, setUpdateAccessModalParams] = React.useState({ show: false, frequency: "", clientId: '', accessLevel: "" });
  const { ifaData } = useAuth();
  const tableRef = React.useRef();

  const getIFAClients = async (id) => {
    let res = await AdminServices.getIFAClients(id).then(res => res);
    if (res.type === true) {
      let aa = res.data;
      // if (!(ifaData?.email?.endsWith('@mintbox.ai'))) {
      //   aa = aa.filter((el) => {
      //     let d = new Date(el?.CreatedOn);
      //     let month = d.getMonth();
      //     let year = d.getFullYear();
      //     return year >= 2023 && month >= 6;
      //   })
      // }
      getClientPortfolios(aa)

    }
  }

  const getClientPortfolios = async (aa) => {
    let res = await AdminServicesPYV2.getAllClientsPortfolioConsolidated().then((r) => { return r })
    // set_pt_data(res?.data)

    console.log(aa)
    var final_a = res?.data?.map((i) => {

      return {
        "total_wealth": i?.stocks + i?.mf + i?.etf,
        "fetch_time": i?.stocksTime && i?.mfTime && i?.etfTime ? new Date(i?.stocksTime || i?.etfTime) > new Date(i?.mfTime) ? new Date(i?.stocksTime || i?.etfTime) : new Date(i?.mfTime) : new Date(i?.stocksTime || i?.etfTime || i?.mfTime),
        ...i,
        ...aa?.filter((a) => a?.ClientId === i?.client_id)?.[0]
      }
    })


    setData(final_a)
    setDisplayData(final_a);

    var akk = final_a.reduce((acc, curr) => {
      acc.total_wealth += curr.total_wealth;
      acc.stocks += curr.stocks;
      acc.etf += curr.etf;
      acc.mf += curr.mf;
      return acc;
    }, { total_wealth: 0, stocks: 0, etf: 0, mf: 0 });

    setTotalD(akk)

    setLoading(false)
    setreportLoading(false);
  }

  React.useEffect(() => {
    getIFAClients(-1)
  }, [])

  const updateAccess = async () => {
    let client = data?.find((e) => e?.ClientId === updateAccessModalParams?.clientId)
    let userTracked = await moengage.add_unique_user_id("SHARPELY-" + client?.ClientId);
    if (userTracked) {
      moengage.add_email(client.Email)
      moengage.add_mobile(client.MobileNumber)
      moengage.add_user_name(client.DisplayName)
      moengage.add_user_attribute("SharpelyAccessLevel", client.SharpelyAccessLevel);
    }
    let res = await AdminServices.updateSharpelyAccess({ clientId: client?.ClientId, newAccessLevel: updateAccessModalParams?.accessLevel, frequency: updateAccessModalParams?.frequency });
    if (userTracked) {
      moengage.add_user_attribute("SharpelyAccessLevel", updateAccessModalParams?.accessLevel);
    }
    moengage.destroy_session();
    moengage.track_event('Logout');
    if (res.type === true) {
      toast.success('Access updated.')
    }
    else {
      toast.error('Something went wrong.');
    }
    setUpdateAccessModalParams({ show: false, frequency: "", clientId: '', accessLevel: "" })
  }

  const columns = [
    {
      title: 'Client Id',
      dataIndex: 'ClientId',
      key: 'ClientId',
      sorter: (a, b) => a.ClientId - b.ClientId,
      render: (text, record) => <div>{text || record?.client_id}</div>,
      width: 100
    },
    {
      title: 'Client name',
      dataIndex: 'DisplayName',
      key: 'DisplayName',
      width: 150,
      render: (text, obj) => {
        return (
          <div style={{ width: "100%", gap: "0.75rem" }} className="d-flex align-items-center justify-content-between">
            <div className="textEllipsis1">{text}</div>
            <Dropdown menu={{
              items: [
                {
                  key: "loginLocalHost",
                  label: <span className="textXS w-700 dark4">Local login</span>,
                  onClick: () => {
                    if (!(ifaData?.email?.endsWith('@mintbox.ai'))) {
                      toast.error(`Access denied. You can't perform this action.`)
                    }
                    // else if (ifaData?.email === 'arpit@mintbox.ai') {
                    //   window.open('https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExZjJqaTBwdHhnang2OWkyNzhuaTd0MGo0cjJzcWgwa3g0ZTl3ZWhzdyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/wKc00qp7XTCVhXFJev/giphy.gif')
                    // }
                    else {
                      window.open(`http://localhost:3000?auto_login_user=true&loginUserId=l1czA/hCG2HOfC6dV6ewfQfhK4NQKTyqYfBTPLcgIok="${obj?.ClientId}"&isAdmin=1`)
                    }
                  }
                },
                {
                  key: "prodLogin",
                  label: <span className="textXS w-700 dark4">Prod login</span>,
                  onClick: () => {
                    if (!(ifaData?.email?.endsWith('@mintbox.ai'))) {
                      toast.error(`Access denied. You can't perform this action.`)
                    }
                    // else if (ifaData?.email === 'arpit@mintbox.ai') {
                    //   window.open('https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExZjJqaTBwdHhnang2OWkyNzhuaTd0MGo0cjJzcWgwa3g0ZTl3ZWhzdyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/wKc00qp7XTCVhXFJev/giphy.gif')
                    // }
                    else {
                      window.open(`https://sharpely.in?auto_login_user=true&loginUserId=l1czA/hCG2HOfC6dV6ewfQfhK4NQKTyqYfBTPLcgIok="${obj?.ClientId}"&isAdmin=1`)
                    }
                  }
                },
                {
                  key: "devLogin",
                  label: <span className="textXS w-700 dark4">Dev login</span>,
                  onClick: () => {
                    if (!(ifaData?.email?.endsWith('@mintbox.ai'))) {
                      toast.error(`Access denied. You can't perform this action.`)
                    }
                    // else if (ifaData?.email === 'arpit@mintbox.ai') {
                    //   window.open('https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExZjJqaTBwdHhnang2OWkyNzhuaTd0MGo0cjJzcWgwa3g0ZTl3ZWhzdyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/wKc00qp7XTCVhXFJev/giphy.gif')
                    // }
                    else {
                      window.open(`https://dev.sharpely.in?auto_login_user=true&loginUserId=l1czA/hCG2HOfC6dV6ewfQfhK4NQKTyqYfBTPLcgIok="${obj?.ClientId}"&isAdmin=1`)
                    }
                  }
                }
              ]
            }}>
              <button style={{ background: "var(--white)", border: "1px solid var(--grey2)", borderRadius: "var(--borderRadius)" }}>
                <BsThreeDotsVertical size={12} />
              </button>
            </Dropdown>
          </div>
        )
      }
    },
    {
      title: "Plan",
      dataIndex: "SharpelyAccessLevel",
      key: "SharpelyAccessLevel",
      filters: [
        { text: "Free", value: 1 },
        { text: "Lite", value: 2 },
        { text: "Pro", value: 3 },
        { text: "Enterprise", value: 4 }
      ],
      onFilter: (value, record) => record.SharpelyAccessLevel === value,
      width: 70
    },
    {
      title: 'Total Wealth',
      dataIndex: 'total_wealth',
      key: 'total_wealth',
      sorter: (a, b) => a.total_wealth - b.total_wealth,
      render: (text, obj) => <div>
        {CurrencyFormat(text, "short", 2)}
        {text && <span className="primary mx-2" style={{ cursor: "pointer" }} onClick={() => window.open(`https://sharpely.in/wealthview?auto_login_user=true&loginUserId=l1czA/hCG2HOfC6dV6ewfQfhK4NQKTyqYfBTPLcgIok="${obj?.ClientId}"&isAdmin=1`)}><FaChartPie className="primary" /></span>}
      </div>,
      filterSearch: true,
      width: 150
    },
    {
      title: 'Stock Wealth',
      dataIndex: 'stocks',
      key: 'stocks',
      sorter: (a, b) => a.stocks - b.stocks,
      render: (text, obj) => <div>
        {CurrencyFormat(text, "short", 2)}

      </div>,
      filterSearch: true,
      width: 150
    },
    {
      title: 'ETF Wealth',
      dataIndex: 'etf',
      key: 'etf',
      sorter: (a, b) => a.etf - b.etf,
      render: (text, obj) => <div>
        {CurrencyFormat(text, "short", 2)}
      </div>,
      filterSearch: true,
      width: 150
    },
    {
      title: 'MF Wealth',
      dataIndex: 'mf',
      key: 'mf',
      sorter: (a, b) => a.mf - b.mf,
      render: (text, obj) => <div>
        {CurrencyFormat(text, "short", 2)}
      </div>,
      filterSearch: true,
      width: 150
    },
    {
      title: 'Email',
      dataIndex: 'Email',
      key: 'Email',
      filterSearch: true,
      width: 150
    },
    {
      title: 'Mobile no.',
      dataIndex: 'MobileNumber',
      key: 'MobileNumber',
      width: 150
    },
    {
      title: 'Last fetched',
      dataIndex: 'fetch_time',
      key: 'fetch_time',
      sorter: (a, b) => a.fetch_time - b.fetch_time,
      render: (text) => <div>{formatDate(formatDateyyyymmdd(text))}</div>,
      width: 150
    }
  ];

  const exportToCsv = () => {
    const preventCols = ["One time", "Update access", "Subscriptions", "Next due on"];

    const filteredData = data?.filter((ele) => {
      if (Object.keys(appliedFilters || {})?.length === 0) {
        return true;
      }
      else {
        let c = Object.entries(appliedFilters || {})?.every(([key, val]) => Array.isArray(val) ? val?.includes(ele[key]) : val === null);
        return c;
      }
    })
    console.log(filteredData)
    const csvContent = [
      columns?.filter((el) => !preventCols.includes(el.title)).map((column) => column.title).join(','), // Header row
      ...filteredData.map((record) => columns?.filter((el) => !preventCols.includes(el.title)).map((column) => record[column.dataIndex]).join(',')),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'table_data.csv';
    link.click();
  };

  if (loading) {
    return <ActivityLoaderMintbox />
  }
  return (
    <React.Fragment>
      <Card style={{ borderRadius: "var(--borderRadius)" }}>

        <div className="mb-4" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", gap: "2rem" }}>
          <Card className={styles['aum-card-dashboard']} bordered={true}>
            <div className='d-flex align-items-center justify-content-between'>
              <div>
                <div className="w-500" style={{ fontSize: "15px" }}>No. of users</div>
                {/* <div className=" textLight" style={{ fontSize: "12px" }}>(Total number of clients)</div> */}
              </div>
              <Tag color='dodgerblue' className='p-1'>
                <FaUserFriends size='16px' />
              </Tag>
            </div>
            <Divider style={{ margin: "8px 0px" }} />
            <div className="fontH1 w-500" style={{ marginBottom: "0px", fontSize: "20px" }}>{data?.length}</div>
          </Card>

          {Object.entries(totalD)?.map(([key, val]) => {
            return <Card className={styles['aum-card-dashboard']} bordered={true}>
              <div className='d-flex align-items-center justify-content-between'>
                <div>
                  <div className="w-500" style={{ fontSize: "15px", textTransform: "capitalize" }}>{key?.replace("_", " ")}</div>
                  {/* <div className=" textLight" style={{ fontSize: "12px" }}>(Total number of clients)</div> */}
                </div>
                <Tag color='dodgerblue' className='p-1'>
                  <FaUserFriends size='16px' />
                </Tag>
              </div>
              <Divider style={{ margin: "8px 0px" }} />
              <div className="fontH1 w-500" style={{ marginBottom: "0px", fontSize: "20px" }}>{CurrencyFormat(val, "short")}</div>
            </Card>
          })}
        </div>

        <div className='d-flex align-items-center justify-content-between'>
          <CardHeader heading={'All clients'} />
          <Input
            type="text"
            placeholder="Search by client id / email"
            value={searchText}
            style={{ width: "15rem", background: "var(--grey4)" }}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <button className='btnWhite' onClick={exportToCsv} style={{ marginLeft: "1.25rem" }}><IoMdDownload /></button>
        </div>
        <Divider style={{ margin: "1rem 0" }} />
        <MyTable tableRef={tableRef} paginationSize={50} columns={columns} dataSource={data.filter((item) => {
          if (!searchText && searchText !== 0) {
            return true;
          }
          // return item['Email']?.includes(searchText)
          return (item['ClientId'] === Number(searchText) || item['Email']?.includes(searchText) || isSubsequence(searchText, item['DisplayName']) || isSubsequence(searchText, String(item['MobileNumber'])));
        })} scroll={{ x: "max-content", y: "65vh" }} style={{
          border: "1px solid var(--grey2)",
          borderRadius: "var(--borderRadius)"
        }} onChange={(a, b, c, d) => {
          console.log(a, b, c, d)
          setAppliedFilters(b)
        }} />
      </Card>
      {showClientSubs && <ClientSubscriptions clientId={selectedClient?.ClientId} drawerOpen={showClientSubs} toggle={() => setShowClientSubs(false)} client={selectedClient} />}
      {showClientOneTimePay && <ClientOneTimePays clientId={selectedClient?.ClientId} client={selectedClient} drawerOpen={showClientOneTimePay} toggle={() => setShowClientOneTimePay(false)} />}
      <Modal open={updateAccessModalParams?.show} centered title={<div className="textLG w-700 dark4">Update access</div>} onCancel={() => {
        setUpdateAccessModalParams({ show: false, frequency: "", clientId: '', accessLevel: "" })
      }} onOk={() => {
        updateAccess();
      }}>
        <div>
          <div className="textSM w-500 dark3 mb-3">Select frequency</div>
          <Radio.Group value={updateAccessModalParams?.frequency} onChange={(e) => {
            setUpdateAccessModalParams(prev => {
              return {
                ...prev,
                frequency: e.target.value
              }
            })
          }}>
            <Radio value={''}>Today</Radio>
            <Radio value={'1M'}>1M</Radio>
            <Radio value={'6M'}>6M</Radio>
            <Radio value={'1Y'}>1Y</Radio>
          </Radio.Group>
        </div>
      </Modal>
    </React.Fragment>
  )
}